import React from 'react'
import PopupLoader from '../../views/popups/PopupLoader'
import { MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit'
import { useTranslation } from 'react-i18next'

function EditWarning(props) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <PopupLoader
        title="Warning"
        content={
          <>
            <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
              <MDBIcon
                fas
                icon="exclamation-triangle"
                className="me-3 fs-5 mt-1"
                color="warning"
              />
              <div>There are unsaved changes. Click <b>OK</b> to proceed without saving or <b>Cancel</b> to remain on the current page.</div>
            </div>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={(e) => props.warningToggle()}>{t("cancel")}</MDBBtn>
              <MDBBtn onClick={(e) => props.onOk()}>{t("ok")}</MDBBtn>
            </MDBModalFooter>
          </>
        }
        onShow={props.setShowWarning}
        onClose={props.warningToggle}
      />

    </>
  )
}

export default EditWarning
